import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    alertContainer: {
        marginBottom: theme.spacing(3),
    },
    sectionsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        marginTop: theme.spacing(5),
    },
}));
